import Rx from 'ub_wrapped/rx';
import * as rxUi from 'ub/control/rx-ui';

export const panelEventsSubject = new Rx.Subject();
export const textEvents = new rxUi.Binding('TextElementInline');



// WEBPACK FOOTER //
// ./src/ui/inline-text/states/inline-text-state-subjects.js